import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { api, publicApi } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await publicApi.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Could not send reset email");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center p-6">
            <div className="max-w-md w-full" data-testid="forgot-root">
                <Link to="/" className="flex items-center gap-2 mb-10">
                    <div className="w-7 h-7 bg-white text-black flex items-center justify-center font-display font-black text-sm">R</div>
                    <span className="font-display font-bold">RepurposeAI</span>
                </Link>
                <div className="font-mono-ui text-xs tracking-[0.25em] uppercase text-zinc-500 mb-2">// RESET PASSWORD</div>
                <h1 className="font-display font-black text-4xl tracking-tighter">Forgot password?</h1>

                {sent ? (
                    <div className="mt-6 border border-white/10 p-6 bg-[#0a0a0a]">
                        <p className="text-zinc-300" data-testid="forgot-sent">
                            If an account exists for <span className="font-mono-ui text-white">{email}</span>, we just sent a password reset link. Check your inbox.
                        </p>
                        <Link to="/login" data-testid="forgot-back-login" className="mt-6 inline-block text-white underline-offset-4 hover:underline">← Back to login</Link>
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <p className="text-zinc-400 text-sm">Enter your email, we'll send a reset link.</p>
                        <div>
                            <Label htmlFor="email" className="font-mono-ui text-[10px] tracking-[0.25em] uppercase text-zinc-500">Email</Label>
                            <Input data-testid="forgot-email-input" id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11 bg-transparent border-white/15 focus:border-white text-white" />
                        </div>
                        <Button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="w-full h-11 bg-white text-black hover:bg-zinc-200 font-semibold">
                            {loading ? "Sending…" : "Send reset link →"}
                        </Button>
                        <Link to="/login" className="block text-sm text-zinc-500 hover:text-white">← Back to login</Link>
                    </form>
                )}
            </div>
        </div>
    );
}
